import React, { FC, useCallback, useEffect } from 'react';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import { useAppDispatch, useAppSelector } from 'src/modules/shared/hooks/useAppDispatch';
import {
  setActiveFilter,
  setRefresh,
  setSelectedGroup,
  setSelectedStudent,
} from 'src/modules/shared/slices/filters/entity/FiltersSlice';
import { useUser } from 'src/modules/shared';
import AugmentationButton from '../AugmentationButton';
import { CircularProgress } from '@material-ui/core';

const TeacherFiltersControls: FC = () => {
  const dispatch = useAppDispatch();
  const refresh = useAppSelector((state) => state.filters.refresh);
  const selectedGroup = useAppSelector((state) => state.filters.selectedGroup);
  const filterMode = useAppSelector((state) => state.filters.filterMode);
  const isFetching = useAppSelector((state) => state.filters.isFetching);
  const { isTeacher } = useUser();

  const handleRefreshScoresAndProgress = useCallback(() => {
    dispatch(setRefresh(true));
  }, [dispatch]);

  const handleSwitchTeacherFilterOff = () => {
    dispatch(setActiveFilter(undefined));
    dispatch(setSelectedGroup(''));
    dispatch(setSelectedStudent(''));
  };

  useEffect(() => {
    if (refresh) dispatch(setRefresh(false));
  }, [refresh, dispatch]);

  return (
    <div
      style={{
        display: 'flex',
        marginLeft: '1rem',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {filterMode === 'trajectory' &&
        (isFetching ? (
          <CircularProgress />
        ) : (
          <AugmentationButton
            icon={SpriteIconsLight.REFRESH}
            // TODO - check message to display if any!!
            blockedMessage="Available only for teachers."
            onButtonClick={handleRefreshScoresAndProgress}
            blocked={!isTeacher}
            disabled={selectedGroup === ''}
          />
        ))}

      {filterMode !== 'trajectory' && isFetching && <CircularProgress size={16} />}

      {filterMode !== 'scoring' && (
        <AugmentationButton
          icon={SpriteIconsLight.CANCEL}
          blockedMessage="Available only for teachers."
          onButtonClick={handleSwitchTeacherFilterOff}
          blocked={!isTeacher}
        />
      )}
    </div>
  );
};

export default TeacherFiltersControls;
